module.exports = __webpack_public_path__ + "img/weather.fada21d5.svg";